/* JD Cart — eigen cart-drawer van JD Empire.
   - De lade zelf wordt door Shopify gerenderd (sections/jd-cart.liquid); na elke wijziging halen we
     de nieuwe HTML op via de Section Rendering API. Alles wat je in de thema-editor instelt, komt dus
     1-op-1 in de lade.
   - Bewust oude JS-syntax (geen ?. / ?? / class fields), zodat ook oudere iPhones hem draaien.
   Publieke API (ook voor apps en Quick add): window.cartDrawer.open(), .close(), .refresh(), .add(items)
   Events op document: jd-cart:rendered, jd-cart:open, jd-cart:close, jd-cart:added, cart:updated */
(function () {
  'use strict';

  var SECTION = 'jd-cart';
  var nativeFetch = window.fetch.bind(window);
  var ownRequest = 0; // > 0 terwijl we zelf een verzoek doen (dan niet als app-verzoek zien)

  function qs(el, sel) { return el ? el.querySelector(sel) : null; }
  function qsa(el, sel) { return el ? Array.prototype.slice.call(el.querySelectorAll(sel)) : []; }
  function store(type) { try { return window[type]; } catch (e) { return null; } }
  function sget(k) { var s = store('sessionStorage'); try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function sset(k, v) { var s = store('sessionStorage'); try { if (s) { if (v === null) s.removeItem(k); else s.setItem(k, v); } } catch (e) {} }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\{\{\s*([a-z_]+)\s*\}\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; });
  }

  function JdCart(root) {
    this.root = root;
    this.ds = root.dataset;
    this.base = this.ds.root || '/';
    this.cart = null;
    this.busy = false;
    this.recCache = {};
    this.timers = [];
    this.syncing = false;
    this.lastSignature = null;
    this.unlockedBefore = {};
    root.hidden = false;
    this.readCart();
    this.bind();
    this.hydrate(true);
  }

  JdCart.prototype.url = function (path) { return this.base.replace(/\/$/, '') + '/' + path.replace(/^\//, ''); };

  /* ---------- verzoeken ---------- */
  JdCart.prototype.request = function (path, body, opts) {
    var self = this;
    opts = opts || {};
    var payload = body || {};
    var isForm = (typeof FormData !== 'undefined') && payload instanceof FormData;
    if (opts.render !== false) {
      if (isForm) { payload.append('sections', SECTION); payload.append('sections_url', window.location.pathname); }
      else { payload.sections = SECTION; payload.sections_url = window.location.pathname; }
    }
    var init = { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (isForm) { init.body = payload; } else { init.headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(payload); }
    ownRequest++;
    self.setBusy(true);
    return nativeFetch(self.url(path), init).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) { var err = new Error(json.description || json.message || 'Cart error'); err.status = res.status; err.json = json; throw err; }
        return json;
      });
    }).then(function (json) {
      if (json && json.sections && json.sections[SECTION]) self.render(json.sections[SECTION]);
      return json;
    }).finally(function () { ownRequest--; self.setBusy(false); });
  };

  JdCart.prototype.refresh = function () {
    var self = this;
    ownRequest++;
    return nativeFetch(window.location.pathname + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) { if (json && json[SECTION]) self.render(json[SECTION]); return self.cart; })
      .catch(function () {})
      .finally(function () { ownRequest--; });
  };

  JdCart.prototype.add = function (items, opts) {
    var self = this;
    opts = opts || {};
    var body = items instanceof FormData ? items : { items: items };
    return self.request('cart/add.js', body).then(function (json) {
      document.dispatchEvent(new CustomEvent('jd-cart:added', { detail: json }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      if (opts.open !== false && self.ds.openOnAdd === 'true') self.open();
      return json;
    });
  };

  JdCart.prototype.change = function (key, quantity, extra) {
    var body = { id: key, quantity: quantity };
    if (extra) for (var k in extra) body[k] = extra[k];
    return this.request('cart/change.js', body).then(function (json) {
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      return json;
    });
  };

  /* ---------- tekenen ---------- */
  JdCart.prototype.render = function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#JdCart .jd-cart__panel');
    var panel = qs(this.root, '.jd-cart__panel');
    if (!fresh || !panel) return;
    var scroll = qs(panel, '[data-jd-scroll]');
    var top = scroll ? scroll.scrollTop : 0;
    var focusSel = document.activeElement && panel.contains(document.activeElement) ? this.focusSelector(document.activeElement) : null;
    panel.innerHTML = fresh.innerHTML;
    var nscroll = qs(panel, '[data-jd-scroll]');
    if (nscroll) nscroll.scrollTop = top;
    if (focusSel) { var f = qs(panel, focusSel); if (f) f.focus(); }
    // stijl-blok (kleuren uit de editor) ook verversen
    var freshStyle = doc.querySelector('#JdCart style'); var style = qs(this.root, 'style');
    if (freshStyle && style) style.textContent = freshStyle.textContent;
    this.readCart();
    this.hydrate(false);
  };

  JdCart.prototype.focusSelector = function (el) {
    var line = el.closest('[data-jd-line]');
    var attrs = ['data-jd-qty-input', 'data-jd-code-input', 'data-jd-note', 'data-jd-addon-toggle', 'data-jd-variant-select', 'data-jd-plan-select'];
    for (var i = 0; i < attrs.length; i++) {
      if (el.hasAttribute(attrs[i])) return (line ? '[data-jd-line="' + line.getAttribute('data-jd-line') + '"] ' : '') + '[' + attrs[i] + ']';
    }
    return null;
  };

  JdCart.prototype.readCart = function () {
    var node = qs(this.root, '[data-jd-cart-json]');
    try { this.cart = node ? JSON.parse(node.textContent) : null; } catch (e) { this.cart = null; }
    var count = this.cart ? this.cart.item_count : 0;
    qsa(document, '[data-cart-count]').forEach(function (n) { n.textContent = count; n.hidden = count === 0; });
  };

  JdCart.prototype.setBusy = function (on) { this.busy = on; this.root.classList.toggle('is-busy', !!on); };

  JdCart.prototype.toast = function (msg) {
    var panel = qs(this.root, '.jd-cart__inner'); if (!panel) return;
    var t = document.createElement('div'); t.className = 'jd-cart__toast'; t.setAttribute('role', 'alert'); t.textContent = msg;
    panel.appendChild(t); setTimeout(function () { t.remove(); }, 3500);
  };

  /* ---------- openen / sluiten ---------- */
  JdCart.prototype.open = function () {
    if (this.ds.redirectCart === 'true' && !('designMode' in this.ds)) { window.location.href = this.ds.cartUrl; return; }
    this.lastFocus = document.activeElement;
    this.root.classList.add('is-open');
    document.documentElement.classList.add('jd-cart-lock');
    var panel = qs(this.root, '.jd-cart__panel');
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
    qsa(document, '[data-cart-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    this.hydrateUpsells();
    document.dispatchEvent(new CustomEvent('jd-cart:open'));
  };

  JdCart.prototype.close = function () {
    this.root.classList.remove('is-open');
    document.documentElement.classList.remove('jd-cart-lock');
    qsa(document, '[data-cart-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    document.dispatchEvent(new CustomEvent('jd-cart:close'));
  };

  JdCart.prototype.isOpen = function () { return this.root.classList.contains('is-open'); };

  /* ---------- events ---------- */
  JdCart.prototype.bind = function () {
    var self = this;
    var root = this.root;

    this.onDocClick = function (e) {
      var toggle = e.target.closest('[data-cart-toggle], a[href="' + self.ds.cartUrl + '"]:not([data-jd-no-drawer])');
      if (toggle && !root.contains(toggle) && self.ds.redirectCart !== 'true') {
        e.preventDefault();
        self.open();
        self.refresh();
      }
    };
    document.addEventListener('click', this.onDocClick);

    // Eigen checks (voorwaarden, verplichte notitie) vóór externe checkouts als Lasso,
    // die in de capture-fase op checkout-knoppen klikken onderscheppen.
    this.onCheckoutCapture = function (e) {
      var btn = e.target.closest && e.target.closest('[data-jd-checkout]');
      if (btn && root.contains(btn) && !self.canCheckout()) { e.preventDefault(); e.stopImmediatePropagation(); }
    };
    document.addEventListener('click', this.onCheckoutCapture, true);
    this.onSubmitCapture = function (e) {
      if (e.target === qs(root, '#JdCartForm') && !self.canCheckout()) { e.preventDefault(); e.stopImmediatePropagation(); }
    };
    document.addEventListener('submit', this.onSubmitCapture, true);

    this.onKey = function (e) {
      if (!self.isOpen()) return;
      if (e.key === 'Escape') self.close();
      if (e.key === 'Tab') self.trapFocus(e);
    };
    document.addEventListener('keydown', this.onKey);

    this.onSubmit = function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement) || root.contains(form)) return;
      var action = form.getAttribute('action') || '';
      var isProductForm = form.matches('[data-product-form]');
      if (!isProductForm && !(self.ds.intercept === 'true' && /\/cart\/add/.test(action))) return;
      if (self.ds.redirectCart === 'true') return; // gewoon naar /cart laten gaan
      if (e.submitter && e.submitter.getAttribute('name') && e.submitter.getAttribute('name') !== 'add' && isProductForm) return;
      e.preventDefault();
      var btn = e.submitter || qs(form, '[type="submit"]');
      self.setAddButton(btn, true);
      self.add(new FormData(form)).catch(function (err) {
        if (err && err.status === 422) { self.open(); self.toast(err.message || self.ds.textMax); return; }
        // Netwerkfout of drukte bij Shopify: gewoon het gewone Shopify-formulier versturen (geen drawer),
        // zodat de klant nooit op een kapotte pagina belandt. form.submit() slaat deze handler over.
        try { HTMLFormElement.prototype.submit.call(form); } catch (e) { window.location.href = self.ds.cartUrl; }
      }).finally(function () { self.setAddButton(btn, false); });
    };
    document.addEventListener('submit', this.onSubmit);

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-jd-close]')) { e.preventDefault(); self.close(); return; }
      var line = t.closest('[data-jd-line]');
      if (t.closest('[data-jd-remove]') && line) { self.change(line.getAttribute('data-jd-line'), 0).catch(self.fail.bind(self, line)); return; }
      var q = t.closest('[data-jd-qty-change]');
      if (q && line) {
        var next = Math.max(0, Number(line.getAttribute('data-quantity')) + Number(q.getAttribute('data-jd-qty-change')));
        self.change(line.getAttribute('data-jd-line'), next).catch(self.fail.bind(self, line));
        return;
      }
      var up = t.closest('[data-jd-up-add]');
      if (up) {
        var card = up.closest('[data-jd-up]'); var sel = qs(card, '[data-jd-up-variant]');
        var vid = Number(sel ? sel.value : up.getAttribute('data-jd-up-add'));
        up.disabled = true;
        self.add([{ id: vid, quantity: 1 }], { open: false }).catch(function (err) { self.toast(err.message || self.ds.textError); }).finally(function () { up.disabled = false; });
        return;
      }
      if (t.closest('[data-jd-code-apply]')) { self.applyCode(); return; }
      var rm = t.closest('[data-jd-code-remove]');
      if (rm) { self.removeCode(rm.getAttribute('data-jd-code-remove')); return; }
      var sb = t.closest('[data-jd-scroll-by]');
      if (sb) { var track = qs(sb.closest('.jd-upsell'), '[data-jd-upsell-track]'); if (track) track.scrollBy({ left: Number(sb.getAttribute('data-jd-scroll-by')) * track.clientWidth * 0.86, behavior: 'smooth' }); return; }
      var gift = t.closest('[data-jd-gift-pick]');
      if (gift) { self.pickGift(gift.getAttribute('data-tier'), Number(gift.getAttribute('data-jd-gift-pick'))); return; }
      var co = t.closest('[data-jd-checkout]');
      if (co && !self.canCheckout()) { e.preventDefault(); }
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      var line = t.closest('[data-jd-line]');
      if (t.matches('[data-jd-qty-input]') && line) { self.change(line.getAttribute('data-jd-line'), Math.max(0, parseInt(t.value, 10) || 0)).catch(self.fail.bind(self, line)); return; }
      if (t.matches('[data-jd-variant-select]') && line) { self.swapVariant(line, Number(t.value)); return; }
      if (t.matches('[data-jd-plan-select]') && line) {
        self.change(line.getAttribute('data-jd-line'), Number(line.getAttribute('data-quantity')), { selling_plan: t.value ? Number(t.value) : null }).catch(self.fail.bind(self, line));
        return;
      }
      if (t.matches('[data-jd-addon-toggle]')) { self.toggleAddon(t.closest('[data-jd-addon]'), t.checked); return; }
      if (t.matches('[data-jd-up-variant]')) {
        var card = t.closest('[data-jd-up]'); var opt = t.options[t.selectedIndex];
        var price = qs(card, '[data-jd-up-price]'); if (price && opt) price.innerHTML = opt.getAttribute('data-price');
        var addBtn = qs(card, '[data-jd-up-add]'); if (addBtn) addBtn.setAttribute('data-jd-up-add', t.value);
        return;
      }
      if (t.matches('[data-jd-terms]')) { var err = qs(root, '[data-jd-terms-error]'); if (err && t.checked) err.hidden = true; }
    });

    var saveNote = debounce(function (val) { self.request('cart/update.js', { note: val }, { render: false }).catch(function () {}); }, 450);
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-jd-note]')) saveNote(e.target.value);
      if (e.target.matches('[data-jd-code-input]') && self.codeMsg) { self.codeMsg = null; var er = qs(root, '[data-jd-code-error]'); if (er) er.hidden = true; }
    });
    root.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-jd-code-input]')) { e.preventDefault(); self.applyCode(); } });

    root.addEventListener('submit', function (e) { if (!self.canCheckout()) e.preventDefault(); });

    document.addEventListener('cart:refresh', function () { self.refresh(); });
    document.addEventListener('jd-cart:refresh', function () { self.refresh(); });
  };

  JdCart.prototype.destroy = function () {
    document.removeEventListener('click', this.onDocClick);
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('submit', this.onSubmit);
    document.removeEventListener('click', this.onCheckoutCapture, true);
    document.removeEventListener('submit', this.onSubmitCapture, true);
    this.timers.forEach(clearInterval);
  };

  JdCart.prototype.trapFocus = function (e) {
    var nodes = qsa(this.root, 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])').filter(function (n) { return n.offsetParent !== null; });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  JdCart.prototype.setAddButton = function (btn, on) {
    if (!btn) return;
    var label = qs(btn, '[data-add-to-cart-label]') || btn;
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; btn._jdText = label.textContent; if (this.ds.textAdding) label.textContent = this.ds.textAdding; }
    else { btn.removeAttribute('aria-busy'); btn.disabled = false; if (btn._jdText) label.textContent = btn._jdText; }
  };

  JdCart.prototype.fail = function (line, err) {
    var msg = (err && err.status === 422) ? (err.message || this.ds.textMax) : this.ds.textError;
    var box = line ? qs(line, '[data-jd-line-error]') : null;
    if (box) { box.textContent = msg; box.hidden = false; } else this.toast(msg);
    this.refresh();
  };

  JdCart.prototype.canCheckout = function () {
    var terms = qs(this.root, '[data-jd-terms]');
    if (terms && !terms.checked) { var err = qs(this.root, '[data-jd-terms-error]'); if (err) err.hidden = false; terms.focus(); return false; }
    var notes = qs(this.root, '[data-jd-notes][data-required="true"] [data-jd-note]');
    if (notes && !notes.value.trim()) { var d = notes.closest('details'); if (d) d.open = true; notes.focus(); return false; }
    return true;
  };

  /* ---------- variant / kortingscode ---------- */
  JdCart.prototype.swapVariant = function (line, variantId) {
    var self = this;
    var key = line.getAttribute('data-jd-line');
    var qty = Number(line.getAttribute('data-quantity'));
    ownRequest++;
    nativeFetch(self.url('cart.js'), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var item = null; cart.items.forEach(function (i) { if (i.key === key) item = i; });
      var props = item ? item.properties : {};
      var add = { id: variantId, quantity: qty, properties: props || {} };
      if (item && item.selling_plan_allocation) add.selling_plan = item.selling_plan_allocation.selling_plan.id;
      return self.request('cart/add.js', { items: [add] }, { render: false });
    }).then(function () { return self.change(key, 0); })
      .catch(self.fail.bind(self, line))
      .finally(function () { ownRequest--; });
  };

  JdCart.prototype.codes = function () { return (this.cart && this.cart.codes ? this.cart.codes : []).map(function (c) { return c.code; }); };

  JdCart.prototype.applyCode = function () {
    var self = this;
    var input = qs(this.root, '[data-jd-code-input]');
    var box = qs(this.root, '[data-jd-code]');
    if (!input || !input.value.trim()) return;
    this.codeMsg = null;
    var code = input.value.trim();
    var list = this.codes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }).concat([code]);
    this.request('cart/update.js', { discount: list.join(',') }).then(function (cart) {
      var hit = null;
      (cart.discount_codes || []).forEach(function (c) { if (c.code.toLowerCase() === code.toLowerCase()) hit = c; });
      if (!hit || !hit.applicable) {
        var keep = (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
        self.codeMsg = { text: box ? box.getAttribute('data-invalid-text') : '', value: code };
        return self.request('cart/update.js', { discount: keep.join(',') });
      }
      self.codeMsg = null;
    }).catch(function () { self.toast(self.ds.textError); });
  };

  JdCart.prototype.removeCode = function (code) {
    var list = this.codes().filter(function (c) { return c !== code; });
    this.request('cart/update.js', { discount: list.join(',') }).catch(function () {});
  };

  /* ---------- na elke render ---------- */
  JdCart.prototype.hydrate = function (first) {
    var self = this;
    this.timers.forEach(clearInterval); this.timers = [];
    this.hydrateTimers();
    this.hydrateRewards(first);
    if (this.codeMsg) {
      var err = qs(this.root, '[data-jd-code-error]'); var inp = qs(this.root, '[data-jd-code-input]');
      if (err) { err.textContent = this.codeMsg.text; err.hidden = false; }
      if (inp && !inp.value) inp.value = this.codeMsg.value;
    }
    if (this.isOpen()) this.hydrateUpsells();
    if (!first) this.syncCart();
    var js = qs(this.root, '[data-jd-custom-js]');
    if (js && js.textContent.trim()) { try { (new Function('cart', js.textContent))(this.root); } catch (e) { console.warn('JD Cart custom JS:', e); } }
    document.dispatchEvent(new CustomEvent('jd-cart:rendered', { detail: { cart: self.cart } }));
  };

  JdCart.prototype.signature = function () {
    if (!this.cart) return '';
    return this.cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|');
  };

  /* Timer in de aankondiging */
  JdCart.prototype.hydrateTimers = function () {
    var self = this;
    var sig = this.signature();
    var changed = this.lastSignature !== null && sig !== this.lastSignature;
    this.lastSignature = sig;
    qsa(this.root, '[data-jd-timer-block]').forEach(function (block) {
      var id = block.getAttribute('data-jd-timer-block');
      var key = 'jdTimer:' + id;
      var minutes = Number(block.getAttribute('data-minutes')) || 0;
      var end = Number(sget(key)) || 0;
      if (!end || (changed && block.getAttribute('data-reset') === 'true')) { end = Date.now() + minutes * 60000; sset(key, String(end)); }
      var spans = qsa(block, '[data-jd-timer]');
      var finished = false;
      var tick = function () {
        var left = Math.max(0, end - Date.now());
        var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
        var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        spans.forEach(function (sp) { sp.textContent = txt; });
        if (left <= 0 && !finished) {
          finished = true;
          var endText = block.getAttribute('data-end-text');
          var txtNode = qs(block, '[data-jd-ann-text]');
          if (endText && txtNode) txtNode.textContent = endText;
          if (block.getAttribute('data-clear') === 'true' && self.cart && self.cart.item_count > 0) {
            sset(key, null);
            self.request('cart/clear.js', {}).catch(function () {});
          }
        }
      };
      tick();
      self.timers.push(setInterval(tick, 1000));
    });
  };

  /* Bedragen */
  JdCart.prototype.rate = function () { var r = window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate); return r > 0 ? r : 1; };

  JdCart.prototype.money = function (cents) {
    var currency = this.cart ? this.cart.currency : this.ds.shopCurrency;
    if (currency && currency !== this.ds.shopCurrency) {
      try { return new Intl.NumberFormat(this.ds.locale || undefined, { style: 'currency', currency: currency }).format(cents / 100); } catch (e) {}
    }
    var format = this.ds.moneyFormat || '${{amount}}';
    function fmt(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[1] ? parts[0] + ds + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  };

  JdCart.prototype.lineTotalExcluded = function () {
    // add-on- en cadeauregels tellen niet mee voor beloningen/tiers
    var sum = 0; var addonIds = this.addonProductIds();
    (this.cart ? this.cart.items : []).forEach(function (i) { if (i.gift || i.addon || addonIds.indexOf(i.product_id) > -1) sum += i.final_line_price; });
    return sum;
  };

  JdCart.prototype.addonProductIds = function () {
    return qsa(this.root, '[data-jd-addon]').map(function (b) { return Number(b.getAttribute('data-product-id')); });
  };

  /* Beloningenbalk */
  JdCart.prototype.hydrateRewards = function (first) {
    var self = this;
    if (!this.cart) return;
    this.giftPlan = [];
    qsa(this.root, '[data-jd-rewards]').forEach(function (block) {
      var tiers = [];
      try { tiers = JSON.parse(qs(block, '[data-jd-rewards-tiers]').textContent).filter(function (t) { return t && t.id; }); } catch (e) { return; }
      if (!tiers.length) return;
      var byCount = block.getAttribute('data-basis') === 'count';
      var factor = byCount ? 1 : 100 * (block.getAttribute('data-convert') === 'true' ? self.rate() : 1);
      tiers.forEach(function (t) { t.target = Math.round(Number(t.value) * factor); });
      tiers.sort(function (a, b) { return a.target - b.target; });
      var current = byCount ? self.cart.real_count
        : (block.getAttribute('data-pre-discount') === 'true' ? self.cart.original_total_price : self.cart.total_price) - self.lineTotalExcluded();
      var max = tiers[tiers.length - 1].target || 1;
      var fillEl = qs(block, '[data-jd-rewards-fill]');
      if (fillEl) fillEl.style.width = Math.min(100, (current / max) * 100) + '%';
      var next = null; var lastDone = null; var newlyUnlocked = false;
      tiers.forEach(function (t, idx) {
        var done = current >= t.target;
        var pos = (t.target / max) * 100;
        var step = qs(block, '[data-jd-step="' + t.id + '"]');
        if (step) { step.style.left = pos + '%'; step.classList.toggle('is-done', done); }
        var label = qs(block, '[data-jd-label="' + t.id + '"]');
        if (label) { label.style.left = pos + '%'; label.classList.toggle('is-done', done); label.classList.toggle('is-last', idx === tiers.length - 1 && pos > 85); }
        if (done) { lastDone = t; if (!first && !self.unlockedBefore[t.id]) newlyUnlocked = true; }
        else if (!next) next = t;
        self.unlockedBefore[t.id] = done;
        if (t.type === 'gift') self.giftPlan.push({ tier: t, unlocked: done, block: block });
      });
      var textEl = qs(block, '[data-jd-rewards-text]');
      if (textEl) {
        var tpl;
        if (next) {
          var need = next.target - current;
          tpl = byCount ? qs(block, '[data-jd-text-before-count]').innerHTML : qs(block, '[data-jd-text-before]').innerHTML;
          textEl.innerHTML = fill(tpl, { amount: self.money(need), count: String(need), reward: next.label || '' });
        } else {
          tpl = qs(block, '[data-jd-text-unlocked]').innerHTML;
          textEl.innerHTML = fill(tpl, { reward: lastDone ? (lastDone.label || '') : '' });
        }
      }
      qsa(block, '[data-jd-gift-choice]').forEach(function (c) {
        var id = c.getAttribute('data-jd-gift-choice');
        var tier = null; tiers.forEach(function (t) { if (t.id === id) tier = t; });
        var inCart = self.cart.items.some(function (i) { return i.gift === id; });
        c.hidden = !(tier && current >= tier.target);
        qsa(c, '[data-jd-gift-pick]').forEach(function (btn) {
          btn.classList.toggle('is-selected', self.cart.items.some(function (i) { return i.gift === id && i.variant_id === Number(btn.getAttribute('data-jd-gift-pick')); }));
        });
        c.classList.toggle('has-gift', inCart);
      });
      if (newlyUnlocked && block.getAttribute('data-confetti') === 'true') self.confetti();
    });
    if (first) return;
  };

  JdCart.prototype.pickGift = function (tierId, variantId) {
    var self = this;
    var existing = this.cart.items.filter(function (i) { return i.gift === tierId; });
    var chain = Promise.resolve();
    existing.forEach(function (i) { chain = chain.then(function () { return self.request('cart/change.js', { id: i.key, quantity: 0 }, { render: false }); }); });
    chain.then(function () { return self.request('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: { _jd_gift: tierId } }] }); })
      .catch(function (err) { self.toast(err.message || self.ds.textError); });
  };

  /* Cadeaus en add-ons automatisch bijwerken (één ronde per render, geen lussen) */
  JdCart.prototype.syncCart = function () {
    var self = this;
    if (this.syncing || !this.cart) return;
    var ops = [];
    var items = this.cart.items;
    var realItems = this.cart.real_count;

    (this.giftPlan || []).forEach(function (g) {
      var inCart = items.filter(function (i) { return i.gift === g.tier.id; });
      var gifts = (g.tier.gifts || []).filter(function (v) { return v > 0; });
      if (g.unlocked && realItems > 0 && gifts.length === 1 && !inCart.length) ops.push({ add: { id: gifts[0], quantity: 1, properties: { _jd_gift: g.tier.id } } });
      if ((!g.unlocked || realItems === 0) && inCart.length) inCart.forEach(function (i) { ops.push({ change: { id: i.key, quantity: 0 } }); });
      inCart.forEach(function (i) { if (i.quantity > 1) ops.push({ change: { id: i.key, quantity: 1 } }); });
    });

    // weggevallen tiers (blok verwijderd): cadeauregels zonder bijbehorende tier opruimen
    var tierIds = (this.giftPlan || []).map(function (g) { return g.tier.id; });
    items.forEach(function (i) { if (i.gift && tierIds.indexOf(i.gift) === -1 && qsa(self.root, '[data-jd-rewards]').length) ops.push({ change: { id: i.key, quantity: 0 } }); });

    qsa(this.root, '[data-jd-addon]').forEach(function (block) {
      var id = 'jdAddonOff:' + block.getAttribute('data-jd-addon');
      var productId = Number(block.getAttribute('data-product-id'));
      var lines = items.filter(function (i) { return i.product_id === productId; });
      var desired = self.addonVariant(block);
      if (realItems === 0) {
        if (lines.length && block.getAttribute('data-remove-empty') === 'true') lines.forEach(function (l) { ops.push({ change: { id: l.key, quantity: 0 } }); });
        return;
      }
      if (lines.length) {
        lines.forEach(function (l, idx) {
          if (idx > 0 || l.variant_id !== desired) ops.push({ change: { id: l.key, quantity: 0 } });
          else if (l.quantity !== 1) ops.push({ change: { id: l.key, quantity: 1 } });
        });
        if (lines[0].variant_id !== desired && desired) ops.push({ add: { id: desired, quantity: 1, properties: { _jd_addon: '1' } } });
      } else if (block.getAttribute('data-default-on') === 'true' && sget(id) !== '1' && desired) {
        ops.push({ add: { id: desired, quantity: 1, properties: { _jd_addon: '1' } } });
      }
    });

    if (!ops.length) return;
    this.syncing = true;
    var chain = Promise.resolve();
    ops.forEach(function (op, idx) {
      var last = idx === ops.length - 1;
      chain = chain.then(function () {
        if (op.add) return self.request('cart/add.js', { items: [op.add] }, { render: last });
        return self.request('cart/change.js', op.change, { render: last });
      });
    });
    chain.catch(function () {}).finally(function () {
      self.syncing = false;
      self.refresh();
    });
  };

  JdCart.prototype.addonVariant = function (block) {
    var variants = String(block.getAttribute('data-variants') || '').split(',').map(Number).filter(Boolean);
    if (!variants.length) return 0;
    var raw = String(block.getAttribute('data-tiers') || '').split(/<br\s*\/?>/i);
    var subtotal = (this.cart.total_price - this.lineTotalExcluded()) / 100 / this.rate();
    var pick = 1;
    raw.forEach(function (line) {
      var m = line.match(/^\s*([\d.,]+)\s*[:=]\s*(\d+)/);
      if (!m) return;
      var min = Number(m[1].replace(',', '.'));
      if (subtotal >= min) pick = Number(m[2]);
    });
    return variants[Math.min(Math.max(pick, 1), variants.length) - 1];
  };

  JdCart.prototype.toggleAddon = function (block, on) {
    var self = this;
    var key = 'jdAddonOff:' + block.getAttribute('data-jd-addon');
    var productId = Number(block.getAttribute('data-product-id'));
    sset(key, on ? null : '1');
    if (on) {
      var v = this.addonVariant(block);
      if (v) this.add([{ id: v, quantity: 1, properties: { _jd_addon: '1' } }], { open: false }).catch(function (e) { self.toast(e.message || self.ds.textError); });
    } else {
      var lines = this.cart.items.filter(function (i) { return i.product_id === productId; });
      var chain = Promise.resolve();
      lines.forEach(function (l, idx) { chain = chain.then(function () { return self.request('cart/change.js', { id: l.key, quantity: 0 }, { render: idx === lines.length - 1 }); }); });
    }
  };

  /* Upsells: Shopify-aanbevelingen ophalen en filteren */
  JdCart.prototype.hydrateUpsells = function () {
    var self = this;
    var inCart = (this.cart ? this.cart.items : []).map(function (i) { return i.product_id; });
    qsa(this.root, '[data-jd-upsell]').forEach(function (block) {
      var track = qs(block, '[data-jd-upsell-track]');
      var max = Number(block.getAttribute('data-max')) || 6;
      var hide = block.getAttribute('data-hide-in-cart') === 'true';
      var finish = function () {
        var cards = qsa(track, '[data-jd-up]');
        var seen = {};
        cards.forEach(function (c) {
          var pid = Number(c.getAttribute('data-product-id'));
          if ((hide && inCart.indexOf(pid) > -1) || seen[pid]) { c.remove(); return; }
          seen[pid] = true;
        });
        qsa(track, '[data-jd-up]').forEach(function (c, i) { if (i >= max) c.remove(); });
        block.classList.toggle('is-empty', !qs(track, '[data-jd-up]'));
      };
      var src = block.getAttribute('data-source');
      var base = block.getAttribute('data-base-product');
      if (src === 'manual' || !base || block.hasAttribute('data-jd-loaded')) { finish(); return; }
      block.setAttribute('data-jd-loaded', '');
      var intent = block.getAttribute('data-intent') || 'related';
      var cacheKey = base + ':' + intent;
      var get = self.recCache[cacheKey] ? Promise.resolve(self.recCache[cacheKey])
        : nativeFetch(self.url('recommendations/products') + '?product_id=' + base + '&limit=10&intent=' + intent + '&section_id=jd-cart-recs', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) { self.recCache[cacheKey] = html; return html; });
      get.then(function (html) {
        if (!html) { finish(); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var btnText = block.getAttribute('data-button-text');
        var showBadge = block.getAttribute('data-show-badge') === 'true';
        var showCompare = block.getAttribute('data-show-compare') === 'true';
        var badgeTpl = block.getAttribute('data-badge-text');
        qsa(doc, '[data-jd-up]').forEach(function (card) {
          var add = qs(card, '[data-jd-up-add]'); if (add && btnText) add.textContent = btnText;
          var badge = qs(card, '[data-jd-up-badge]');
          if (badge) { badge.hidden = !showBadge; if (badgeTpl) badge.textContent = fill(badgeTpl, { percent: card.getAttribute('data-percent') }); }
          var cmp = qs(card, '[data-jd-up-compare]'); if (cmp) cmp.hidden = !showCompare;
          track.appendChild(document.importNode(card, true));
        });
        finish();
      }).catch(finish);
    });
  };

  JdCart.prototype.confetti = function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var c = document.createElement('canvas'); c.className = 'jd-confetti'; document.body.appendChild(c);
    var ctx = c.getContext('2d'); c.width = window.innerWidth; c.height = window.innerHeight;
    var colors = ['#f94144', '#f3722c', '#f9c74f', '#90be6d', '#43aa8b', '#577590', '#b5179e'];
    var parts = []; for (var i = 0; i < 140; i++) parts.push({ x: c.width / 2, y: c.height / 3, vx: (Math.random() - 0.5) * 14, vy: Math.random() * -12 - 4, s: Math.random() * 6 + 4, r: Math.random() * 6, col: colors[i % colors.length] });
    var start = Date.now();
    (function frame() {
      ctx.clearRect(0, 0, c.width, c.height);
      parts.forEach(function (p) { p.vy += 0.35; p.x += p.vx; p.y += p.vy; p.r += 0.1; ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.col; ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6); ctx.restore(); });
      if (Date.now() - start < 2600) requestAnimationFrame(frame); else c.remove();
    })();
  };

  /* ---------- verzoeken van apps opmerken (zoals Upcart/Kaching) ---------- */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  function onAppCartRequest(url) {
    var inst = window.jdCart;
    if (!inst) return;
    var isAdd = /\/cart\/add/.test(url) && !/opens_cart=never/.test(url);
    setTimeout(function () {
      inst.refresh().then(function () { if (isAdd && inst.ds.openOnAdd === 'true') inst.open(); });
    }, 60);
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (ownRequest === 0 && CART_RE.test(url)) {
      p.then(function (r) { if (r && r.ok) onAppCartRequest(url); }).catch(function () {});
    }
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (CART_RE.test(String(url))) {
        var self = this;
        this.addEventListener('load', function () { if (ownRequest === 0 && self.status >= 200 && self.status < 300) onAppCartRequest(String(url)); });
      }
    } catch (e) {}
    return xhrOpen.apply(this, arguments);
  };

  /* ---------- start ---------- */
  function init() {
    var root = document.getElementById('JdCart');
    if (!root) return;
    if (window.jdCart) window.jdCart.destroy();
    window.jdCart = new JdCart(root);
    window.cartDrawer = {
      open: function () { window.jdCart.open(); },
      close: function () { window.jdCart.close(); },
      refresh: function () { return window.jdCart.refresh(); },
      add: function (items, opts) { return window.jdCart.add(items, opts); }
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Thema-editor: sectie opnieuw geladen / geselecteerd
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('#JdCart')) { init(); window.jdCart.open(); } });
  document.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('#JdCart')) window.jdCart.open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('#JdCart')) window.jdCart.close(); });
  document.addEventListener('shopify:block:select', function (e) {
    if (!window.jdCart || !window.jdCart.root.contains(e.target)) return;
    window.jdCart.open();
    if (e.target.scrollIntoView) e.target.scrollIntoView({ block: 'nearest' });
  });
})();
